import { render } from "./PayVideoListEditModal.vue?vue&type=template&id=47a217b1&scoped=true"
import script from "./PayVideoListEditModal.vue?vue&type=script&lang=js"
export * from "./PayVideoListEditModal.vue?vue&type=script&lang=js"

import "./PayVideoListEditModal.vue?vue&type=style&index=0&id=47a217b1&scoped=true&lang=less"
import "./PayVideoListEditModal.vue?vue&type=style&index=1&id=47a217b1&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a217b1"]])

export default __exports__